export default {
    fic_color: "#FF1A9A",
    bic_color: "#18F5CA",
    fic_bic_color: "#7F7EFF",
};
